import React from "react";
import BrandLogo from "../../images/icons/logo.svg";

const LoadingScreen = () => {
  return (
    <section className={"loader-wrapper"}>
      <div id="loader-wrapper">
        <div id="loader" className="new-loader">
          <img className="logo-white loader-logo" src={"https://ggfx-davidastburys.s3.eu-west-2.amazonaws.com/i.prod/new_logo_9a41a946af.png"} alt="logo" />
        </div>
      </div>
    </section>
  );
};

export default LoadingScreen;
